import { render } from "./Models.vue?vue&type=template&id=9536b656&scoped=true&ts=true"
import script from "./Models.vue?vue&type=script&lang=ts"
export * from "./Models.vue?vue&type=script&lang=ts"

import "./Models.vue?vue&type=style&index=0&id=9536b656&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9536b656"]])

export default __exports__